import HeaderRepository from "@adapters/repositories/Header";
import FooterRepository from "@adapters/repositories/Footer";
import HomeRepository from "@adapters/repositories/Home";
import CommonRepository from "@adapters/repositories/Common/Common";
import WebinarShareRepo from "@adapters/repositories/webinar/WebinarShare";
import FeedbackRepository from "@adapters/repositories/feedback/feedback";
import { commonQuotesHomePageRepository, newsStream, qouteStream } from "@di";
import LiveNewsRepository from "@adapters/features/LiveNews/Repository/liveNews";
export default (http) => {
    return {
        header: new HeaderRepository(http),
        home: new HomeRepository(commonQuotesHomePageRepository, http),
        footer: new FooterRepository(http),
        quoteStream: qouteStream,
        webinarShare: new WebinarShareRepo(http),
        feedback: new FeedbackRepository(http),
        common: new CommonRepository(http),
        newsStream: newsStream,
        liveNews: new LiveNewsRepository(http),
    };
};
